export const __EventDetailLang = {
    title: 'جزئیات ایونت',
    edit: 'ویرایش اطلاعات',
    return: 'بازگشت',
    contentTitle: 'اطلاعات ایونت',
    title_label: 'عنوان ایونت',
    title_placeholder: 'عنوان ایونت را بنویسید',
    title_error: 'لطفا نام ایونت را وارد کنید.',
    category_label: 'دسته بندی',
    category_placeholder: 'انتخاب کنید',
    category_error: 'لطفا دسته بندی را وارد کنید.',
    capacity_label: 'ظرفیت ایونت',
    capacity_placeholder: 'ظرفیت ایونت چند نفر است',
    capacity_patternError: 'لطفا عدد وارد کنید',
    capacity_error: 'لطفا ظرفیت ایونت را وارد کنید.',
    cost_label: 'هزینه',
    cost_placeholder: 'هزینه ایونت',
    cost_error: 'لطفا هزینه را وارد کنید.',
    cost_patternError: 'لطفا عدد وارد کنید.',
    date_label: 'تاریخ برگزاری',
    date_placeholder: 'انتخاب تاریخ',
    date_error: 'لطفا تاریخ برگزاری را وارد کنید.',
    clock_label: 'ساعت برگزاری',
    clock_placeholder: 'ساعت برگزاری جلسه',
    clock_error: 'لطفا ساعت جلسه را وارد کنید.',
    desc_label: 'توضیحات',
    desc_placeholder: 'توضیحات درباره ایونت را بنویسید',
    desc_error: 'لطفا توضیحات ایونت را وارد کنید.',
    terms_label: 'شرایط استفاده',
    terms_placeholder: 'شرایط شرکت در ایونت را بنویسید',
    terms_error: 'لطفا شرایط شرکت در ایونت را وارد کنید.',
    address_label: 'مکان برگزاری',
    address_placeholder: 'آدرس برگزاری ایونت',
    address_error: 'لطفا آدرس دقیق را وارد کنید.',
    geo_error: 'لطفا موقعیت جغرافیایی را انتخاب کنید.',
    gallery_label: 'گالری تصاویر ایونت',
    gallery_error: 'لطفا تصاویر گالری را وارد کنید.',
    submit: 'تایید ویرایش',
    address_p: 'آدرس محل برگزاری ایونت را روی نقشه تعیین و آدرس کلی آن را به صورت نوشتاری در بخش بالا بنویسید.',
    address_note: 'توجه: آدرس دقیق شما نمایش داده نخواهد شد.',
    request_title: 'درخواست های شرکت',
    download_btn: 'دانلود فایل اکسل',
    awaiting_host: 'در انتظار تایید میزبان',
    rejected: 'رد شده',
    pending: 'در انتظار برگزاری',
    held: 'برگزار شده',
    user_title: 'کاربر',
    number_title: 'تعداد',
    date_title: 'تاریخ درخواست',
    status_title: 'وضعیت',
    detail_title: 'جزئیات',
    number_text: 'نفر',
    expand_btn: 'مشاهده',
    collapsed_title: 'توضیحات کاربر:',
    collapsed_phone: 'شماره تماس:',
    collapsed_reject: 'رد درخواست',
    collapsed_confirm: 'تایید درخواست',
    isActive: 'این ایونت همچنان فعال است',
    notActive: 'این ایونت غیرفعال شده است.',
};
